/**
 * Sometimes a component will start an async process (e.g. an API call) then do something with the result
 * which modifies the state of the component. It's possible that a component gets destroyed (unmounted)
 * in the meantime. In that case we don't want to do whatever happens in the async response.
 * This mixin adds a simple unmounted property which can be checked to see if async responses should
 * be handled.
 */
export const UnmountedMixin = {
    data() {
        return {
            unmounted: false,
        };
    },

    beforeUnmount() {
        this.unmounted = true;
    },
};
